
import type { BrowseConfiguration } from '@empathybroker/tsclient-play/dist/models/browse-configuration'
import type { ConfigurationToolIdEnum } from '../../enums'
import type { DataTableColumn, DataTableOption } from '../../models'
import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'

import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'

import { defineComponent } from 'vue'

import { mapGetters } from 'vuex'
import ConfigurationFeaturesStatus from '../../components/configurations/configuration-features-status.component.vue'
import CrudList from '../../components/crud/crud-list.component.vue'
import DataTable from '../../components/crud/data-table.component.vue'
import { UiTooltip } from '../../components/keen-ui'
import { EpbText } from '../../components/shared/epb-text'

import { AlignEnum, FeatureIdEnum } from '../../enums'

import { ConfigurationsFormMixin, CrudListMixin, RestrictedMixin } from '../../mixins/'

import { ROUTER_CONSTS } from '../../router/router.consts'

import { APP_CONSTS } from '../../store/app/app.consts'

export default defineComponent({
  name: 'BrowseConfigurationsList',
  components: {
    ConfigurationFeaturesStatus,
    CrudList,
    DataTable,
    EpbText,
    UiTooltip,
  },
  mixins: [CrudListMixin, RestrictedMixin],
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      featuresTree: APP_CONSTS.getters.featuresTree,
    }),
    requestFilters() {
      return { attributeValue: this.$route.params[ROUTER_CONSTS.params.attribute.value] }
    },
    tableColumns(): DataTableColumn[] {
      const fieldsMessages = this.messages.fields
      return !this.$epb.oidcLogin
        ? [
            {
              id: 'name',
              text: fieldsMessages.name.label,
              sortable: true,
              width: '75%',
            },
            ...this.pivotsColumns,
            {
              id: 'modified',
              text: fieldsMessages.features.label,
              width: '13rem',
              align: AlignEnum.CENTER,
            },
            {
              id: 'inheritance',
              text: fieldsMessages.inheritance.label,
              width: '8rem',
              align: AlignEnum.CENTER,
            },
            {
              id: 'meta.updateDate',
              text: fieldsMessages.updateDate.label,
              sortable: true,
            },
            {
              id: 'meta.user',
              text: fieldsMessages.user.label,
              sortable: true,
            },
            {
              id: 'restricted',
              text: fieldsMessages.restricted.label,
              align: AlignEnum.CENTER,
            },
            {
              id: 'enabled',
              text: fieldsMessages.enabled.label,
              sortable: true,
            },
            {
              id: 'options',
              width: '44px',
              align: AlignEnum.CENTER,
            },
          ]
        : [
            {
              id: 'name',
              text: fieldsMessages.name.label,
              sortable: true,
              width: '75%',
            },
            ...this.pivotsColumns,
            {
              id: 'modified',
              text: fieldsMessages.features.label,
              width: '13rem',
              align: AlignEnum.CENTER,
            },
            {
              id: 'inheritance',
              text: fieldsMessages.inheritance.label,
              width: '8rem',
              align: AlignEnum.CENTER,
            },
            {
              id: 'meta.updateDate',
              text: fieldsMessages.updateDate.label,
              sortable: true,
            },
            {
              id: 'meta.user',
              text: fieldsMessages.user.label,
              sortable: true,
            },
            {
              id: 'enabled',
              text: fieldsMessages.enabled.label,
              sortable: true,
            },
            {
              id: 'options',
              width: '44px',
              align: AlignEnum.CENTER,
            },
          ]
    },
    readOnlyDataItemIds(): string[] {
      return this.getReadOnlyIdsFromData(this.data)
    },
    tools(): ConfigurationToolIdEnum[] {
      return ConfigurationsFormMixin.computed.tools.bind(this)()
    },
  },
  data() {
    return {
      dataType: ActionTypeEnum.CONFIGURATION,
      routes: {
        create: ROUTER_CONSTS.routes[FeatureIdEnum.CONFIGURATION][DomainEnum.BROWSE].create,
        update: ROUTER_CONSTS.routes[FeatureIdEnum.CONFIGURATION][DomainEnum.BROWSE].update,
      },
      ignoreQuery: true,
      messages: this.$epb.messages.tools.configurations,
    }
  },
  methods: {
    getInheritanceLabel(inheritance: boolean): string {
      const inheritanceStatesMessages = this.messages.fields.inheritance.states
      return inheritance ? inheritanceStatesMessages.enabled : inheritanceStatesMessages.disabled
    },
    onRowClick(dataItem: BrowseConfiguration): void {
      this.navigateToRoute(this.routes.update, dataItem)
    },
    onCheckboxClick(dataItem: BrowseConfiguration): void {
      if (this.readOnly || this.readOnlyDataItemIds.includes(dataItem.id)) {
        this.navigateToRoute(this.routes.update, dataItem)
      }
    },
    onOptionsClick(option: DataTableOption, dataItem) {
      this.onOptionClick(option, dataItem, this.$refs.crudListRef)
    },
  },
})
